import { Box, Button } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {approveMultipleCG,approveMultiplePG, getCustomerGroups, getProductGroups, setState } from "./cgpgSlice";

export default function ButtonGroup() {
   const dispatch = useDispatch();
   const state = useSelector((store) => store.cgpgApproval);

   const {
      selectedRows,
      selectedView,
      productGroups,
      customerGroups,
      productGroupsTable,
      customerGroupsTable,
      selectedCountryID,
      selectedGroupStatus,
      selectedPeriod,
      searchText
   } = state;  


   function search() {
      
      dispatch(setState("customerGroups", null));
      dispatch(setState("productGroups", null));
      dispatch(setState("rejectSelectedComment", ""));
      dispatch(setState("selectedRows", []));

		const obj = {
			logedUser: JSON.parse(localStorage.getItem("data")),
			countryId: selectedCountryID,
			groupStatus: selectedGroupStatus,
			period: selectedPeriod,
			searchText: searchText,
		};

		if (selectedView === "Product Group") {
			dispatch(getProductGroups(obj));
		} else {
			dispatch(getCustomerGroups(obj));
		}
	}

   function collapseDetailPanel() {
      dispatch(setState("detailPanelCollapseToken", Date.now()));
   }

   function approveSelected() {
      collapseDetailPanel();
      const user = JSON.parse(localStorage.getItem("data"));
      let itemList = [];
      for (let i = 0; i < selectedRows.length; ++i) {
         const id = selectedRows[i];

         let item = null;
         if(selectedView === "Product Group") {
            item = productGroups.find((pg) => pg.productGroupID === id);
         }
         else {
            item = customerGroups.find((cg) => cg.customerGroupID === id);
         }
         const obj = {
            ...item,
            isApprove: 1,
            userRole:user.roleName,
            user
         };
         itemList.push(obj);
      }
      console.log("Approve_CGPG_ApproveRejectSelected", itemList);

      if(selectedView === "Product Group") {
         dispatch(approveMultiplePG(itemList)).then(() => {
            search();
          });
      }
      else {
         dispatch(approveMultipleCG(itemList)).then(() => {
            search();
          });
      }
   }

   function openRejectionModal() {
      collapseDetailPanel();
      dispatch(setState("rejectMultiModalOpen", true));
   }

   return ((productGroupsTable!=null || customerGroupsTable!=null ) &&
      <Box>
         <Box
            sx={{
               mt: 2,
               display: "flex",
               flexDirection: "row",
               justifyContent: "flex-end",
            }}
         >
            <Button
               sx={{
                  bgcolor: "darkred.light",
                  color: "white.main",
                  textTransform: "none",
                  fontWeight: "bold",
                  mt: 1,
                  ml: 1,
                  "&:hover": {
                     bgcolor: "darkred.main",
                     color: "white.main",
                  },
               }}
               disabled={selectedRows.length === 0}
               onClick={approveSelected}
            >
               Approve Selected
            </Button>

            <Button
               sx={{
                  bgcolor: "darkred.light",
                  color: "white.main",
                  textTransform: "none",
                  fontWeight: "bold",
                  mt: 1,
                  ml: 1,
                  "&:hover": {
                     bgcolor: "darkred.main",
                     color: "white.main",
                  },
               }}
               disabled={selectedRows.length === 0}
               onClick={openRejectionModal}
            >
               Reject Selected
            </Button>
         </Box>
      </Box>
   );
}
